/* eslint-disable */
import React, {useState} from 'react';
import Card from '@material-ui/core/Card';
import Divider from '@material-ui/core/Divider';
import Axios from 'axios';
import '../css/SupportPage.css';

/**
 * This function renders the ClientServicesCenter page
 * @component ClientServicesCenterPage
 * @return {Component} ClientServicesCenterPage component
 */
export default function ClientServicesCenterPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [organization, setOrganization] = useState('');
  const [message, setMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');


  const handleSubmit = (event) => {
    event.preventDefault();

    const data = {
      name: name,
      email: email,
      phone: phone,
      organization: organization,
      message: message,
    }

    Axios.post(
      'https://ais-backend-server.herokuapp.com/api/supportTickets',
      data,
    )
      .catch((error) => {
        console.log(error);
      });


    setSuccessMessage("Ticket recieved!");
  };


  return (
    <div className="support-container">
      <Card
        style={{
          padding: '80px',
          margin: '0 auto',
        }}
      >
        <h1>Client Services Center</h1>

        <Divider />
        <br />
        <div style={{fontSize: '18px'}}>
          <strong>Point of Contact</strong>
          <p>Jim D. Ray, Jr., Founder & C.E.O.</p>
          <br />
          <strong>Telephone/Fax Toll-Free</strong>
          <p>1-800-427-9479</p>
          <br />
          <strong>Mailing Address</strong>
          <p>
            Advanced Intelligence Services, Incorporated
            <br />
            Purdue Technology Center
            <br />
            9800 Connecticut Drive
            <br />
            Crown Point, Indiana 46307
          </p>
          <br />
          <strong>Client Services</strong>
          <p>services@aisincorporated.com</p>
          <br />
          <strong>Techincal Support</strong>
          <p>support@aisincorporated.com</p>
          <br />
          <strong>Government Relations</strong>
          <p>gov@aisincorporated.com</p>
          <br />
          <strong>Investor Relations</strong>
          <p>invest@aisincorporated.com</p>
          <br />
          <strong>Media Relations</strong>
          <p>media@aisincorporated.com</p>
          <br />
          <strong>Employment Opportunities</strong>
          <p>employment@aisincorporated.com</p>
          <br />
          <strong>Internship Opportunities</strong>
          <p>internships@aisincorporated.com</p>
        </div>
        <br />
        {/* <div className="support-contact-form">
          <h2>Contact Us</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Name"
              onChange={(e) => setName(e.target.value)}
              value={name}
            />
            <input
              type="text"
              name="organization"
              placeholder="Organization"
              onChange={(e) => setOrganization(e.target.value)}
              value={organization}
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
            <input
              type="text"
              name="phone"
              placeholder="Phone"
              onChange={(e) => setPhone(e.target.value)}
              value={phone}
            />
            <textarea
              type="text"
              name="message"
              placeholder="Message"
              onChange={(e) => setMessage(e.target.value)}
              value={message}
            ></textarea>
            <button type="submit">Submit</button>
            <br />
            <h3 color='green'>{successMessage}</h3>
          </form>
        </div> */}
      </Card>
    </div>
  );
}
